<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="pricelistfactors_heading_id" [ttModel]="edit.heading_id" ttReadonly></tt-input>
        <tt-input ttLabel="pricelistfactors_heading_name" [ttModel]="edit.heading_name" ttReadonly></tt-input>
        <tt-input-number *ngFor="let item of inputListFactors" [ttLabel]="item.pricelist_name" [(ttModel)]="item.factorbased_factor" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
